import { render, staticRenderFns } from "./PaymentWizardOption.vue?vue&type=template&id=19ac5b5d&"
import script from "./PaymentWizardOption.vue?vue&type=script&lang=js&"
export * from "./PaymentWizardOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports